import { create } from 'zustand';
import { RequestStatus } from '@/shared/model/requestStatus';
import { getErrorMessage } from '@/shared/lib/errors';
import { voxServiceService } from '../api/voxServiceService';
import type { VoxServiceState } from './types';

/** Хранит каталог карточек услуг */
export const useVoxServices = create<VoxServiceState>((set, get) => ({
    catalog: null,
    status: RequestStatus.Idle,
    error: null,
    revision: 0,

    load: async () => {
        const revision = get().revision + 1;

        set({
            revision,
            status: RequestStatus.Loading,
            error: null
        });

        try {
            const catalog = await voxServiceService.getCatalog();

            if (get().revision !== revision) return;

            set({
                catalog,
                status: RequestStatus.Success
            });
        } catch (error: unknown) {
            if (get().revision !== revision) return;

            set({
                status: RequestStatus.Error,
                error: getErrorMessage(error, 'Не удалось загрузить карточки услуг')
            });
        }
    },

    reset: () => set({
        catalog: null,
        status: RequestStatus.Idle,
        error: null,
        revision: get().revision + 1
    }),
}));

